
define('ldsh!modules/estimate_line/list/row', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '  \n  <td>\n   <span name="name"></span>\n  </td>\n  \n  <td>\n   <span name="description"></span>\n  </td>\n  \n  <td>\n   <span name="unit_cost"></span>\n  </td>\n  \n  <td>\n   <span name="quantity"></span>\n  </td>\n  \n  <td>\n   <span name="tax1_name"></span>\n  </td>\n  \n  <td>\n   <span name="tax2_name"></span>\n  </td>\n  \n  <td>\n   <span name="tax2_percent"></span>\n  </td>\n  \n  <td>\n   <span name="tax1_percent"></span>\n  </td>\n  \n  <td>\n   <span name="type"></span>\n  </td>\n\n  <td>\n   \t\t<a href="javascript:;" class="edit-item">Edit</a>\n  </td>\n  <td>\n   \t\t<a href="javascript:;" class="delete-item">Delete</a>\n  </td>\n';

}
return __p
};});

